var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"text-center text-gray",staticStyle:{"font-size":"12px"},domProps:{"innerHTML":_vm._s(_vm.getCaption('caption.copyright_traffic_jam_info'))}}),_c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":_vm.iframesrc()}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }